import { Image } from "@mantine/core";
import { useContext } from "react";
import { Element } from "react-scroll";
import { ThemeContext } from "../../context";
import {
  ForSectionColumn,
  ForSectionContainer,
  ForSectionRow,
  ForSectionSec,
  Heading,
  Img,
  ImgWrapper,
  ListContainer,
  ListImageContainer,
  ListText,
  Subtitle,
  TextWrapper,
  TopLine,
} from "./JiffyForSection.elements";
interface ListProp {
  title: string;
  image: string;
  imageDark: string;
}
interface JiffyForSectionProps {
  topLine: string;
  headline: string;
  description: string;
  img: string;
  imgDark: string;
  alt: string;
  imgStart: boolean;
  lightBg: boolean;
  start: string;
  list: ListProp[];
  name: string;
}

const JiffyForSection = (props: JiffyForSectionProps): any => {
  const {
    topLine,
    headline,
    description,
    img,
    imgDark,
    alt,
    imgStart,
    lightBg,
    start,
    list,
    name,
  } = props;
  const { rooTheme } = useContext(ThemeContext);

  return (
    <>
      <Element name={name}>
        <ForSectionContainer
          className="bg-black"
          rooTheme={rooTheme}
          lightBg={lightBg}
        >
          <ForSectionSec lightBg={lightBg} rooTheme={rooTheme}>
            <ForSectionRow imgStart={imgStart}>
              <ForSectionColumn>
                <TextWrapper>
                  <TopLine rooTheme={rooTheme}>{topLine}</TopLine>
                  <Heading rooTheme={rooTheme} lightBg={lightBg}>
                    {headline}
                  </Heading>
                  <Subtitle rooTheme={rooTheme} lightBg={lightBg}>
                    {description}
                  </Subtitle>
                </TextWrapper>
                {list?.map((item: any, index: any) => {
                  return (
                    <ListContainer key={`key-${index}`}>
                      <ListImageContainer rooTheme={rooTheme} lightBg={lightBg}>
                        <Image
                          src={
                            lightBg && rooTheme === "dark"
                              ? item?.imageDark
                              : lightBg && rooTheme === "light"
                              ? item?.image
                              : !lightBg && rooTheme === "dark"
                              ? item?.image
                              : !lightBg && rooTheme === "light"
                              ? item?.imageDark
                              : item?.image
                          }
                          width={25}
                          height={25}
                          fit="cover"
                          alt={`${item?.title}`}
                          withPlaceholder
                        />
                      </ListImageContainer>
                      <ListText rooTheme={rooTheme} lightBg={lightBg}>
                        {item?.title}
                      </ListText>
                    </ListContainer>
                  );
                })}
              </ForSectionColumn>
              <ForSectionColumn>
                <ImgWrapper start={start}>
                  <Img
                    src={
                      lightBg && rooTheme === "dark"
                        ? imgDark
                        : lightBg && rooTheme === "light"
                        ? img
                        : !lightBg && rooTheme === "dark"
                        ? img
                        : !lightBg && rooTheme === "light"
                        ? imgDark
                        : img
                    }
                    alt={alt}
                  />
                </ImgWrapper>
              </ForSectionColumn>
            </ForSectionRow>
          </ForSectionSec>
        </ForSectionContainer>
      </Element>
    </>
  );
};

export default JiffyForSection;
